import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import { Rally as RallyModel } from '@/lib/models/Rally'
import { SerializationHelper } from '@/lib/utils/SerializationHelper'
import { RallyRound } from '@/lib/models/RallyRound'

@Module
export class Rally extends VuexModule {
    rallies: RallyModel[] = []

    get rallyRounds (): RallyRound[] {
      const rallyRounds: RallyRound[] = []
      this.rallies.forEach(rally => {
        rallyRounds.push(...rally.rounds)
      })
      return rallyRounds
    }

    @Mutation
    updateRallies (rallies: RallyModel[]) {
      this.rallies = rallies
    }

    @Action({ commit: 'updateRallies', rawError: true })
    async loadRallies () {
      const rallies = await RallyModel.getAll({})
      rallies.map((rally: RallyModel) => {
        rally.rounds = SerializationHelper.toInstanceArray(RallyRound, rally.rallyRounds.length ? rally.rallyRounds : rally.rounds)
      })
      return rallies
    }
}
